// Treat as blank when there is no rendered text and no embedded media.
// Lexical and other rich-text editors persist empty content as truthy strings
// like "<p></p>", "<p><br></p>" or "<p><span style=\"...\"></span></p>"; those
// render as nothing and should be treated the same as null.
// Standalone <br>/<hr> without text are also blank — they're just empty lines.
export const isBlankHtml = (s: string | null | undefined): boolean => {
    if (!s) return true
    const stripped = s.replace(/<[^>]*>/g, "").replace(/&nbsp;/gi, " ").trim()
    if (stripped.length > 0) return false
    return !/<(img|video|audio|iframe|svg|picture|source|embed|object)[\s/>]/i.test(s)
}
